module.exports = __webpack_public_path__ + "media/login-bg.b49d2e71.mp4";